<template>
    <div id="declare">
        <div class="declare_content">
            <img @click="parentHandleclick()" class="close_img" src="./images/ty_close.png" />
            <img  :src="icon" class="delare_img" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "declareSample",
        props:{
            declareType:String
        },
        data(){
          return{
              icon:require('./images/hezuo.png'),
          }
        },
        watch:{
            declareType(newValue,oldValue){
                if(newValue==="3")
                {
                    this.icon = require("./images/hezuo.png");
                }
                if(newValue==="4")
                {
                    this.icon = require("./images/zhiwu.png");
                }
                if(newValue==="5")
                {
                    this.icon = require("./images/weituo.png");
                }
            }
        },
        methods:{
            parentHandleclick() {
                this.$emit('fatherModal',null);
            }
        },
    }
</script>

<style lang="less" scoped>
#declare{
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    margin: auto;
    z-index: 558;

    .declare_content{
        background:#fff;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        border-radius:8px;
        width: 410px;
        height: 600px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .close_img{
            margin-top:15px;
            margin-right: 15px;
            cursor: pointer;
        }


        .delare_img{
            height: 555px;
            margin-left: 15px;
        }
    }
}
</style>